/* International orders (outside Sri Lanka):
   1) max 4 backdrops per cart  2) one backdrop size per cart  3) one-time guideline pop-up.
   Enabled only when window.RATAA_INTL_CAP.enabled is true (set in sections/cart-drawer.liquid).
   TEST MODE: add ?cap_test=1 to any page URL to force it on (remembered for the browser tab);
   ?cap_test=0 turns the test off. */
(function () {
  var cfg = window.RATAA_INTL_CAP;
  var forced = false;
  try {
    if (/[?&]cap_test=1/.test(window.location.search)) sessionStorage.setItem('rataaCapTest', '1');
    if (/[?&]cap_test=0/.test(window.location.search)) sessionStorage.removeItem('rataaCapTest');
    forced = sessionStorage.getItem('rataaCapTest') === '1';
  } catch (_) {
    forced = /[?&]cap_test=1/.test(window.location.search);
  }
  if (!cfg || !(cfg.enabled || forced)) return;

  var MAX = cfg.max || 4;
  var WA_NUMBER = '94762571057';
  var EMAIL = 'rataabackdrops@gmail.com';
  var CONTACT = 'WhatsApp at +94 76 257 1057 or email us at ' + EMAIL;
  var MSG =
    'For international orders, we can only add ' + MAX + ' backdrops per package. ' +
    'If you want to order more than ' + MAX + ' backdrops, please separate them into two different orders. ' +
    'If you need further assistance, please contact us via ' + CONTACT + '.';
  var toastEl = null;
  var toastTimer = null;

  function el(tag, css, text) {
    var n = document.createElement(tag);
    if (css) n.style.cssText = css;
    if (text) n.textContent = text;
    return n;
  }

  function toast(msg, sticky) {
    if (!toastEl) {
      toastEl = el('div',
        'position:fixed;left:50%;bottom:6rem;transform:translateX(-50%);z-index:100000;' +
        'max-width:min(92vw,460px);background:#111;color:#fff;padding:0.9rem 1.2rem;' +
        'border-radius:6px;box-shadow:0 8px 30px rgba(0,0,0,.3);font-size:14px;line-height:1.45;' +
        'font-family:inherit;text-align:center;');
      toastEl.setAttribute('role', 'alert');
      toastEl.setAttribute('aria-live', 'assertive');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg || MSG;
    toastEl.style.display = 'block';
    clearTimeout(toastTimer);
    if (!sticky) {
      toastTimer = setTimeout(function () {
        toastEl.style.display = 'none';
      }, 12000);
    }
  }

  /* WhatsApp + email links. compact = smaller side-by-side buttons */
  function waLink(text, css) {
    var a = el('a', css, 'Chat on WhatsApp');
    a.href = 'https://wa.me/' + WA_NUMBER + '?text=' + encodeURIComponent(text);
    a.target = '_blank';
    a.rel = 'noopener';
    return a;
  }
  function mailLink(subject, text, css) {
    var a = el('a', css, 'Send us an email');
    a.href = 'mailto:' + EMAIL + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(text);
    return a;
  }

  /* centered pop-up (used for the one-size-per-order message) */
  var sizePopupOpen = false;
  function sizePopup() {
    if (sizePopupOpen) return;
    sizePopupOpen = true;
    if (toastEl) toastEl.style.display = 'none';
    var overlay = el('div',
      'position:fixed;inset:0;z-index:100002;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:1rem;');
    var box = el('div',
      'background:#fff;color:#111;max-width:460px;width:100%;max-height:90vh;overflow:auto;border-radius:12px;padding:1.7rem 1.6rem 1.5rem;box-shadow:0 20px 60px rgba(0,0,0,.35);font-family:inherit;font-size:15px;line-height:1.55;');
    box.setAttribute('role', 'alertdialog');
    box.setAttribute('aria-modal', 'true');
    box.appendChild(el('h2', 'margin:0 0 .4rem;font-size:22px;line-height:1.25;font-weight:700;', 'One size per order'));
    box.appendChild(el('p', 'margin:0 0 .9rem;opacity:.8;', 'Sorry for the inconvenience!'));

    function bullet(label, text) {
      var li = el('li', 'margin:.6rem 0;');
      li.appendChild(el('strong', '', label));
      li.appendChild(document.createTextNode(' ' + text));
      return li;
    }
    var ul = el('ul', 'margin:0 0 1.2rem;padding-left:1.25rem;list-style:disc;');
    ul.appendChild(bullet('Same size only:', 'all backdrops in one website order must be the same size.'));
    ul.appendChild(bullet('Mix and match:', 'you can combine any designs in that size.'));
    ul.appendChild(bullet('Need different sizes?', 'contact us and we will arrange your order separately.'));
    box.appendChild(ul);

    var btnCss = 'display:block;box-sizing:border-box;width:100%;padding:.85rem 1rem;border:0;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;text-align:center;text-decoration:none;margin:0 0 .6rem;';
    var waText = 'Hi Rataa Backdrops, I would like to order backdrops in different sizes.';
    box.appendChild(waLink(waText, btnCss + 'background:#25D366;color:#fff;'));
    box.appendChild(mailLink('Order with different backdrop sizes', waText, btnCss + 'background:#111;color:#fff;'));

    var btn = el('button', btnCss + 'background:#f0f0ee;color:#111;margin-bottom:0;', 'OK, got it');
    btn.type = 'button';
    box.appendChild(btn);
    overlay.appendChild(box);
    document.body.appendChild(overlay);
    function close() {
      sizePopupOpen = false;
      document.removeEventListener('keydown', onKey);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }
    function onKey(ev) {
      if (ev.key === 'Escape') close();
    }
    btn.addEventListener('click', close);
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) close();
    });
    document.addEventListener('keydown', onKey);
    btn.focus();
  }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  /* backdrop size = variant title (e.g. "1.5ft by 2ft"); products without real variants are ignored */
  function sizesIn(cart) {
    var seen = {};
    cart.items.forEach(function (i) {
      var t = i.variant_title;
      if (t && t !== 'Default Title') seen[t] = 1;
    });
    return Object.keys(seen);
  }

  function resubmit(form) {
    form.dataset.capOk = '1';
    if (form.requestSubmit) form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  }

  /* refresh the cart drawer contents and counts after we remove an item */
  function refreshDrawer() {
    var drawer = document.getElementById('cart-drawer');
    Promise.all([fetch('/?sections=cart-drawer').then(function (r) { return r.json(); }), getCart()])
      .then(function (res) {
        var html = res[0]['cart-drawer'];
        var cart = res[1];
        if (drawer && html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var nb = parsed.querySelector('[data-cart-items]');
          var ns = parsed.querySelector('[data-cart-subtotal]');
          var cb = drawer.querySelector('[data-cart-items]');
          var cs = drawer.querySelector('[data-cart-subtotal]');
          if (nb && cb) cb.innerHTML = nb.innerHTML;
          if (ns && cs) cs.textContent = ns.textContent;
        }
        document.querySelectorAll('[data-cart-count]').forEach(function (n) {
          n.textContent = String(cart.item_count || 0);
        });
      })
      .catch(function () {});
  }

  /* after an add: if the cart now holds more than one size, remove what was just added */
  function watchForMix(prevKeys) {
    var tries = 0;
    function check() {
      tries++;
      getCart()
        .then(function (cart) {
          var fresh = cart.items.filter(function (i) {
            return prevKeys.indexOf(i.key) === -1;
          });
          if (!fresh.length) {
            if (tries < 5) setTimeout(check, 600);
            return;
          }
          if (sizesIn(cart).length > 1) {
            var chain = Promise.resolve();
            fresh.forEach(function (i) {
              chain = chain.then(function () {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: i.key, quantity: 0 })
                });
              });
            });
            chain.then(function () {
              refreshDrawer();
              sizePopup();
            });
          }
        })
        .catch(function () {});
    }
    setTimeout(check, 700);
  }

  /* 1. Add to cart: enforce the 4-backdrop cap, then watch for mixed sizes */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target && e.target.closest && e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      if (form.dataset.capOk === '1') {
        form.dataset.capOk = '';
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      var q = parseInt(new FormData(form).get('quantity'), 10);
      if (!q || q < 1) q = 1;
      getCart()
        .then(function (cart) {
          if (cart.item_count + q > MAX) {
            toast();
            return;
          }
          var prevKeys = cart.items.map(function (i) {
            return i.key;
          });
          resubmit(form);
          watchForMix(prevKeys);
        })
        .catch(function () {
          resubmit(form);
        });
    },
    true
  );

  /* 2. Cart quantity + button, and 3. Checkout buttons */
  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var stepBtn = t.closest('[data-change-qty]');
      if (stepBtn) {
        var row = stepBtn.closest('[data-cart-item]');
        var list = stepBtn.closest('ul');
        if (row && list) {
          var cur = parseInt(row.querySelector('[data-qty-display]').textContent, 10) || 0;
          var target = Number(stepBtn.getAttribute('data-qty'));
          var total = 0;
          list.querySelectorAll('[data-qty-display]').forEach(function (n) {
            total += parseInt(n.textContent, 10) || 0;
          });
          if (target > cur && total + (target - cur) > MAX) {
            e.preventDefault();
            e.stopImmediatePropagation();
            toast();
          }
        }
        return;
      }

      var co = t.closest('a[href="/checkout"], button[name="checkout"], input[name="checkout"]');
      if (co) {
        e.preventDefault();
        e.stopImmediatePropagation();
        getCart()
          .then(function (cart) {
            if (sizesIn(cart).length > 1) {
              sizePopup();
            } else if (cart.item_count > MAX) {
              toast('Your cart has ' + cart.item_count + ' backdrops. ' + MSG + ' Please remove ' + (cart.item_count - MAX) + ' to continue.');
            } else {
              window.location.href = '/checkout';
            }
          })
          .catch(function () {
            window.location.href = '/checkout';
          });
      }
    },
    true
  );

  /* 4. On the cart page, warn straight away if the cart already breaks a rule */
  if (/^\/cart\/?$/.test(window.location.pathname)) {
    getCart()
      .then(function (cart) {
        if (sizesIn(cart).length > 1) sizePopup();
        else if (cart.item_count > MAX) toast(MSG + ' Please remove ' + (cart.item_count - MAX) + ' to continue.', true);
      })
      .catch(function () {});
  }

  /* 5. One-time guideline pop-up for international visitors (once per browser session) */
  function showNotice() {
    try {
      if (sessionStorage.getItem('rataaIntlNoticeSeen') === '1') return;
      /* the first-visit country picker comes first; this pop-up shows after the country is chosen */
      var gate = document.getElementById('rataa-gate');
      if (gate && !gate.hidden) return;
    } catch (_) {}

    var overlay = el('div',
      'position:fixed;inset:0;z-index:100001;background:rgba(0,0,0,.55);display:flex;align-items:center;justify-content:center;padding:1rem;');
    var box = el('div',
      'background:#fff;color:#111;max-width:500px;width:100%;max-height:90vh;overflow:auto;border-radius:12px;padding:1.7rem 1.6rem 1.5rem;box-shadow:0 20px 60px rgba(0,0,0,.35);font-family:inherit;font-size:15px;line-height:1.5;');
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Ordering from outside Sri Lanka');

    box.appendChild(el('h2', 'margin:0 0 .3rem;font-size:23px;line-height:1.25;font-weight:700;', 'Ordering from outside Sri Lanka?'));
    box.appendChild(el('p', 'margin:0 0 1rem;opacity:.8;', 'Please note the following for international orders:'));

    function item(label, text) {
      var li = el('li', 'margin:.55rem 0;');
      li.appendChild(el('strong', '', label));
      li.appendChild(document.createTextNode(' ' + text));
      return li;
    }

    var ul = el('ul', 'margin:0 0 1.1rem;padding-left:1.25rem;list-style:disc;');
    ul.appendChild(item('Prices', 'are shown in US dollars (USD) as an approximate amount. You will be charged in Sri Lankan rupees (LKR) at checkout.'));
    ul.appendChild(item('Sizes:', 'only 1.5×2, 2×2 and 2×3 ft are available internationally. For larger sizes, please contact us.'));
    ul.appendChild(item('Order limit:', 'up to ' + MAX + ' backdrops per order, all of one size. For more than ' + MAX + ', place separate orders. To mix sizes, please contact us.'));
    ul.appendChild(item('Delivery:', '10 to 14 days in total.'));
    ul.appendChild(item('Returns:', 'only if you receive the wrong item or it is damaged in delivery. No change-of-mind returns.'));
    ul.appendChild(item('Shipping & duties:', 'shipping is calculated at checkout. Import duties and taxes may apply.'));
    box.appendChild(ul);

    var help = el('div', 'margin:0 0 1.2rem;padding:.8rem .85rem;background:#f5f5f3;border-radius:8px;font-size:14px;');
    var helpTitle = el('p', 'margin:0 0 .6rem;');
    helpTitle.appendChild(el('strong', '', 'Need help? '));
    helpTitle.appendChild(document.createTextNode('Contact us:'));
    help.appendChild(helpTitle);
    var row = el('div', 'display:flex;flex-wrap:wrap;gap:.5rem;');
    var smallCss = 'flex:1 1 140px;box-sizing:border-box;padding:.6rem .8rem;border-radius:8px;font-size:14px;font-weight:600;font-family:inherit;text-align:center;text-decoration:none;cursor:pointer;';
    var helpText = 'Hi Rataa Backdrops, I have a question about ordering from outside Sri Lanka.';
    row.appendChild(waLink(helpText, smallCss + 'background:#25D366;color:#fff;'));
    row.appendChild(mailLink('Question about international order', helpText, smallCss + 'background:#111;color:#fff;'));
    help.appendChild(row);
    box.appendChild(help);

    var btn = el('button',
      'display:block;width:100%;padding:.85rem 1rem;border:0;border-radius:8px;background:#111;color:#fff;font-size:15px;font-weight:600;cursor:pointer;font-family:inherit;',
      'I understand');
    btn.type = 'button';
    box.appendChild(btn);
    overlay.appendChild(box);
    document.body.appendChild(overlay);

    function close() {
      try {
        sessionStorage.setItem('rataaIntlNoticeSeen', '1');
      } catch (_) {}
      document.removeEventListener('keydown', onKey);
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
    }
    function onKey(ev) {
      if (ev.key === 'Escape') close();
    }
    btn.addEventListener('click', close);
    overlay.addEventListener('click', function (ev) {
      if (ev.target === overlay) close();
    });
    document.addEventListener('keydown', onKey);
    btn.focus();
  }

  showNotice();
})();
